// src/pages/copilot/hooks/useCopilotSessionList.js
import { useEffect, useState, useCallback } from 'react';
import api from '../../../lib/axios';

const PATH = 'api/v1/insights';

export function useCopilotSessionList() {
  const [sessions, setSessions] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get(`${PATH}/sessions`);
      setSessions(r.data.sessions || []);
    } catch (err) {
      console.error('List sessions failed:', err);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const create = useCallback(async () => {
    try {
      const r = await api.post(`${PATH}/sessions`);
      await refresh();
      return r.data.session_id;
    } catch (err) {
      console.error('Create session failed:', err);
      return null;
    }
  }, [refresh]);

  const remove = useCallback(async (id) => {
    try {
      await api.delete(`${PATH}/sessions/${id}`);
      await refresh();
    } catch (err) {
      console.error('Delete session failed:', err);
    }
  }, [refresh]);

  return { sessions, refresh, create, remove };
}
